var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
export var SelectMenu = React.forwardRef(function (_a, ref) {
    var onClick = _a.onClick, tabIndex = _a.tabIndex, role = _a.role, onKeyUp = _a.onKeyUp, className = _a.className, props = __rest(_a, ["onClick", "tabIndex", "role", "onKeyUp", "className"]);
    // the Select Component attaches some listeners. We remove them here to support a custom menu.
    return React.createElement("div", __assign({ ref: ref }, props));
});
